// IMPORTS
// OHS
import { OHSFormSubmitListener } from './OHSForm';
// Assets
import './../scss/OHSWidget.scss';


// COMPONENT
export default function OHSWidget (props) {
   // Component
   return (
      <div id={props.id} className='ohswidget' onKeyDown={(e) => {if (props.onEnter) {OHSFormSubmitListener(e, props.onEnter);}}}>
         {props.title ? <div className='ohswidget-title'>
            <p>{props.title}</p>
            <hr />
         </div> : null}
         <div className={`ohswidget-body ${props.className || ""}`}>
            {props.children}
         </div>
      </div>
   );
}